export const NAVIGATION = 'NAVIGATION';
export const INITIALIZATION_ERROR = 'INITIALIZATION_ERROR';

export type NavState = {
  location: string;
  previousLocation: string;
  query: NavigationQueryString;
  queryString: string;
  initErrorStatus?: number;
};

export type NavigationAction = {
  type: typeof NAVIGATION;
  context: PageContext;
};

type InitializationErrorAction = {
  type: typeof INITIALIZATION_ERROR;
  initErrorStatus: number;
  queryString?: string;
};

export type NavActions = NavigationAction | InitializationErrorAction;
